<template lang="pug">

.debug
  .performance(ref="performance")
  ul(v-if='false')
  ul
    li
      .label STAGE
      .value {{ stageLabel }}
    li
      .label PROGRESS
      .value {{ Math.floor(progress * 100) }}%
    li
      .label VELOCITY
      .value {{ Math.round(velocity) }}
    li
      .label BASE VELOCITY
      .value {{ Math.round(baseVelocity) }}
    li
      .label NUM INFRONT
      .value {{ numInfront }}
    li
      .label PACE
      .value {{ Math.round(Math.round(3000000 / velocity / 1000 / 60 * 100) / 100 * 60) }}
    li
      .label DURATION
      .value {{ Math.round(duration / 1000) }}
    li
      .label BLOOM
      .value {{ bloom }}
    li
      .label ZOOM
      .value {{ zoom }}
    //- li(v-if="stage >= STAGES.STAGE2")
    //-   .label STAGE2 BASE
    //-   .value {{ Math.floor(stage2.velocity.base) }}
    //- li(v-if="stage >= STAGES.STAGE2")
    //-   .label STAGE2 GOAL
    //-   .value {{ Math.floor(stage2.velocity.base * breakScale) }}
    //- li(v-if="stage >= STAGES.STAGE2")
    //-   .label STAGE2 AVG
    //-   .value {{ Math.floor(stage2.velocity.avg) }}
    //- li(v-if="stage >= STAGES.STAGE2")
    //-   .label STAGE2 CHARGE
    //-   .value {{ Math.round(stage2.charge * 100) }}%
    //- li
    //-   .label FPS
    //-   .value {{ fps }}
    //- li
    //-   .label RATIO
    //-   .value {{ pixelRatio }}


</template>


<script>
import {mapState} from 'vuex'
import {state as gameState} from 'src/components/game/main'
import * as STAGES from 'src/components/game/stages'
import gameConfig from 'src/components/game/config'
import * as renderer from 'src/components/game/renderer'
import * as controls from 'src/components/game/controls'

export default {
  name: 'debug',
  data () {
    return {
      progress: 0,
      velocity: 0,
      charge: null,
      STAGES: STAGES,
      stage: 0,
      stage2: {
        velocity: {
          base: null,
          avg: null
        },
        charge: 0
      },
      breakScale: gameConfig.breakScale,
      fps: 0,
      pixelRatio: 0,
      numInfront: 0,
      duration: 0,
      baseVelocity: 0,
      bloom: 0,
      zoom: 0
    }
  },
  computed: {
    stageLabel () {
      let stages = [
        'INTRO',
        'STAGE0',
        'STAGE1',
        'STAGE2_SLOW',
        'STAGE2_FAST',
        'STAGE2_AIRPORT',
        'END_NORMAL',
        'END_CUTSCENE',
        'END_SPEED',
        'RESULTS'
      ]
      return stages[this.stage]
    },
    ...mapState({
      debug: state => state.game.debug
    })
  },
  mounted () {
    if (renderer.stats) {
      this.$refs.performance.appendChild(renderer.stats.domElement)
    }
    this.interval = setInterval(this.update, 50)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    update () {
      this.progress = gameState.progress.percent
      this.velocity = gameState.velocity.now
      this.baseVelocity = controls.state.baseVelocity
      this.charge = gameState.stage2.progress
      this.stage = gameState.stage
      this.stage2 = Object.assign({}, gameState.stage2)
      // this.fps = Math.round(renderer.fps)
      // this.pixelRatio = renderer.currRatio
      this.duration = gameState.duration
      this.numInfront = gameState.numInfront
      this.bloom = renderer.multiPassBloomPass.params.blurAmount
      this.zoom = renderer.zoomBlurPass.params.strength
    }
  }

}
</script>


<style lang="sass" scoped>
@import "src/common.sass"

.debug
  position: absolute
  bottom: 0
  left: 0
  // pointer-events: none
  background: #191938
  color: #19FFFF
  font-weight: bold
  font-size: 8px
  min-width: 80px
  min-width: 100px

li
  +flex-center()
  flex-direction: row
  padding: 2px
  height: 24px
  border-bottom: 1px solid #19FFFF

  &:last-child
    border-bottom: none

  div
    flex: 1
    padding: 4px


  .label
    min-width: 54px
    text-transform: uppercase
    text-align: right

  .value
    flex: 1
    text-align: left


</style>



// WEBPACK FOOTER //
// Debug.vue?d9109738